import { CookieOptions } from './cookieTypes'

/**
 * Set cookie by name and value with expiration time in hours from CookieExpirationHours
 * @param name
 * @param value
 * @param options
 */
async function setCookie(name: string, value: string, options: CookieOptions) {
  const attributes = [
    options.expires ? `expires=${options.expires.toUTCString()}` : '',
    options.maxAge !== undefined ? `max-age=${options.maxAge}` : '',
    options.domain ? `domain=${options.domain}` : '',
    options.path ? `path=${options.path}` : '',
    options.secure ? 'secure' : '',
    options.sameSite ? `samesite=${options.sameSite.toLowerCase()}` : '',
    options.httpOnly ? 'httponly' : '',
    options.priority ? `priority=${options.priority}` : '',
  ].filter(Boolean)

  document.cookie = `${name}=${value}; ${attributes.join('; ')}`
}

export { setCookie }
